<template>
    <div class="push-container">
        <div class="push-content">
            <div class="leftBar">
                <sys-sidebar></sys-sidebar>
            </div>
            <div class="rightBar">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import SysSidebar from "../../components/sys-sidebar";
    export default {
        name: "index",
        components: { SysSidebar}
    }
</script>

<style scoped lang="less">
    @import "../../assets/css/content";

    .push-container {
        height: 100vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .push-header-wrap {
        flex-shrink: 0;
        height: auto;
    }

    .push-content {
        flex: 1;
        display: flex;
        overflow: hidden;
        height: 0 !important; // 覆盖 content.less 中的 height: calc(100%)
        min-height: 0; // 确保 flex 子元素可以缩小
        background-color: #eef0f5;
        min-width: 0;
    }

    .push-content .rightBar {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        height: 100%;
        min-height: 0;
        min-width: 0;
    }

    .push-content .rightBar > * {
        flex: 1 1 auto;
        width: 100%;
        min-width: 0;
    }
</style>
